import { zodResolver } from '@hookform/resolvers/zod';
import type { Resolver } from 'react-hook-form';
import type { z } from 'zod';

/**
 * Adapter between Zod 4 and React Hook Form.
 *
 * Zod 4 separates the parser *input* and *output* types (`.default()`, `.coerce`,
 * transforms), while the forms are typed with the output shape used across the
 * UI. The runtime resolver is exactly `zodResolver`; this wrapper only relaxes
 * the resolver generics so `useForm<FormData>` keeps its type and the form
 * values are still validated by the same schema.
 *
 * Do not use it to bypass validation: the schema is always the runtime parser.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function formResolver(schema: z.ZodTypeAny): Resolver<any, any, any> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return zodResolver(schema as never) as unknown as Resolver<any, any, any>;
}
